import type { AppSettings } from '../types'

/**
 * Gets application settings.
 * @returns {AppSettings} Application settings object.
 */
export function getAppSettings(): AppSettings {
  const settingsStore = document.getElementById(
    'travelUpdatesResources'
  ) as HTMLInputElement

  if (!settingsStore?.value) {
    throw new Error(
      'Cannot load travel updates - travel updates settings object not found.'
    )
  }

  const settings: AppSettings = JSON.parse(settingsStore.value || '')

  return settings
}
